import { useEffect, useRef, useState } from 'react';
import { PERMIT_DETAIL } from '@/constants/testIds';

export default function SignaturePad({ onSave, role = 'Signataire' }) {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#09090B';
    ctx.lineWidth = 2.5;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, rect.width, rect.height);
  }, []);

  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    const cy = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: cx - rect.left, y: cy - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    setDrawing(true);
    const ctx = canvasRef.current.getContext('2d');
    const { x, y } = getPos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const draw = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext('2d');
    const { x, y } = getPos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setEmpty(false);
  };

  const stop = () => setDrawing(false);

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, rect.width, rect.height);
    setEmpty(true);
  };

  const validate = () => {
    if (empty) return;
    const dataUrl = canvasRef.current.toDataURL('image/png');
    onSave(dataUrl);
    clear();
  };

  return (
    <div className="space-y-3">
      <div className="label-industrial">Tracez votre signature ci-dessous — Rôle: {role}</div>
      <canvas
        ref={canvasRef}
        data-testid={PERMIT_DETAIL.signatureCanvas}
        className="signature-canvas w-full"
        onMouseDown={start}
        onMouseMove={draw}
        onMouseUp={stop}
        onMouseLeave={stop}
        onTouchStart={start}
        onTouchMove={draw}
        onTouchEnd={stop}
      />
      <div className="flex gap-3">
        <button
          type="button"
          data-testid={PERMIT_DETAIL.signatureClear}
          onClick={clear}
          className="btn-industrial-secondary flex-1"
        >
          Effacer
        </button>
        <button
          type="button"
          data-testid={PERMIT_DETAIL.signatureValidate}
          onClick={validate}
          disabled={empty}
          className="btn-industrial-primary flex-1"
        >
          Valider la signature
        </button>
      </div>
    </div>
  );
}
